import * as React from 'react';
import RouterController from '../src/routers/controladorDeRotas'

export default function Dashboard() {
  return (
    <RouterController />
  );
}
